import React from "react";

import segment1 from "../../../shared/assets/images/segment1.png";
import segment2 from "../../../shared/assets/images/segment2.png";
import segment3 from "../../../shared/assets/images/segment3.png";
import segment4 from "../../../shared/assets/images/segment4.png";

import "./Segments.scss";

const AnalyzeSegments = (props) => {
  return (
    <div className="segments">
      <div className="segments-row">
        <div>&nbsp;</div>
        <div className="col-header">
          <img src={segment1} alt="Wealthy Young" />
        </div>
        <div className="col-header">
          <img src={segment2} alt="Budget Young" />
        </div>
        <div className="col-header">
          <img src={segment3} alt="Mature" />
        </div>
        <div className="col-header">
          <img src={segment4} alt="Calm Areas" />
        </div>
      </div>
      <div className="segments-row">
        <div>&nbsp;</div>
        <div className="col-1-header col-header">Wealthy Young</div>
        <div className="col-2-header col-header">Budget Young</div>
        <div className="col-3-header col-header">Mature</div>
        <div className="col-4-header col-header">Calm Areas</div>
      </div>
      <div className="segments-row">
        <div className="segments-row-header">Number of stores</div>
        <div className="segments-row-content">7</div>
        <div className="segments-row-content">6</div>
        <div className="segments-row-content">8</div>
        <div className="segments-row-content">5</div>
      </div>
      <div className="segments-row">
        <div className="segments-row-header">Daily footfall</div>
        <div className="segments-row-content inactive">8k/d</div>
        <div className="segments-row-content inactive">11k/d</div>
        <div className="segments-row-content inactive">8k/d</div>
        <div className="segments-row-content active">4k/d</div>
      </div>
      <div className="segments-row">
        <div className="segments-row-header">Age</div>
        <div className="segments-row-content active">{"50% < 37y"}</div>
        <div className="segments-row-content active">{"42% < 37 year"}</div>
        <div className="segments-row-content active">{"38% < 37 year"}</div>
        <div className="segments-row-content inactive">{"42% < 37 year"}</div>
      </div>
      <div className="segments-row">
        <div className="segments-row-header">High income</div>
        <div className="segments-row-content active">58%</div>
        <div className="segments-row-content active">46%</div>
        <div className="segments-row-content">50%</div>
        <div className="segments-row-content">52%</div>
      </div>
      <div className="segments-row">
        <div className="segments-row-header">Interested in fashion</div>
        <div className="segments-row-content active">8%</div>
        <div className="segments-row-content">6%</div>
        <div className="segments-row-content">5%</div>
        <div className="segments-row-content">5%</div>
      </div>
      <div className="segments-row">
        <div className="segments-row-header">
          Interested in holiday shopping
        </div>
        <div className="segments-row-content">27%</div>
        <div className="segments-row-content">26%</div>
        <div className="segments-row-content">26%</div>
        <div className="segments-row-content">26%</div>
      </div>
      <div className="segments-row">
        <div className="segments-row-header">Interested in fitness</div>
        <div className="segments-row-content">77%</div>
        <div className="segments-row-content">77%</div>
        <div className="segments-row-content">75%</div>
        <div className="segments-row-content">74%</div>
      </div>
    </div>
  );
};

export default React.memo(AnalyzeSegments);
